import React from "react";
import Banner from "./Banner";
import Feature from "./Feature";
import About from "./About";
import Counter from "./Counter";
import Services from "./Services";
import WorkStep from "./WorkStep";
import Portfolio from "./Portfolio";
import SuccessProjects from "./SuccessProjects";
import Team from "./Team";
import Testimonial from "./Testimonial";
import Brand from "./Brand";
import Blog from "./Blog";
import Categories from "./Categories";
import Products from "./Products";
// import Contact from "./Contact";

const Home = () => {
  return (
    <div>
      <Banner />
      {/* <Feature /> */}
      <About />
      <Categories />
      <Products />
      {/* <Counter /> */}
      {/* <Services /> */}
      {/* <WorkStep /> */}
      {/* <Portfolio /> */}
      {/* <SuccessProjects /> */}
      {/* <Team /> */}
      {/* <Testimonial /> */}
      {/* <Brand /> */}
      {/* <Blog /> */}
      {/* <Contact /> */}
    </div>
  );
};

export default Home;
